import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dropdown, Table, Select, Drawer, Tag, Popconfirm, Modal, Spin, Button, Tooltip, Divider } from 'antd';
import { EditOutlined, FilterOutlined, LockOutlined, UnlockOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import BOMActions from '@Actions/bomActions';
import searchIcon from '@Images/icons/icon-search.png';
import Helpers from '@Apis/helpers';
import { QUANTITY, toISTDate } from '@Apis/constants';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ProductBOM from '@Components/Inventory/ManageProducts/ViewProduct/ProductBOMList/ProductBOM';
import ProductActions from '@Actions/productActions';
import ProductCategoryLabel from '@Components/Common/ProductCategoryLabel';
import BulkImportBOM from './BulkImport';
import PRZModal from '../../Common/UI/PRZModal';
import PRZText from '../../Common/UI/PRZText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faLock, faPen, faTrash, faUnlock } from '@fortawesome/free-solid-svg-icons';
import PRZSelect from '../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../hooks/useCheckPortrait';
import './style.scss';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../apis/constants';
import UserSavedFilterViewSelector from '../../Common/UserSavedFilterViewSelector';

const { Option } = Select;

function BOMList({
  history, getBOMByIdSuccess, user, getBOM, billOfMaterials, getBOMLoading, deleteBOM, deleteBOMLoading, products, getProductsLoading, getProducts,
}) {
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [showViewProductBOMModal, setShowViewProductBOMModal] = useState(false);
  const [selectedBomId, setSelectedBomId] = useState(null);
  const [showUpdateBOMDrawer, setShowUpdateBOMDrawer] = useState(false);
  const [selectedBomProductName, setSelectedBomProductName] = useState('');
  const [showBulkReturnsDrawer, setShowBulkReturnsDrawer] = useState(false);
  const [createBOMDrawer, setCreateBOMDrawer] = useState(false);
  const [call, setCall] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchByProduct, setSearchByProduct] = useState('');
  const [showPRZModal, setShowPRZModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const isRowDisabled = (record) => {
    let isDisable = false;
    if (user?.tenant_info?.production_config?.addons?.access_restriction?.is_active) {
      if ((record?.is_restricted && record?.bom_users.includes(user?.user_id)) || (!record?.is_restricted && record?.bom_users === null)) {
        isDisable = false;
      } else isDisable = true;
    }
    return isDisable;
  };

  const columns = [
    {
      title: '',
      render: (record) => (
        <div className="mobile-list__card">
          <div className="mobile-list__card_header">
            <div className="mobile-list__card_header-left">
              <PRZText className="mobile-list__card_item-number" text={`#${record?.bom_number ? record.bom_number : 'N/A'}`} />
            </div>
            <div className="mobile-list__card_header-right">
              <PRZText
                style={{ backgroundColor: record?.is_active ? '#2fbc6e' : '#ee2232', height: 'fit-content' }}
                text={record?.is_active ? 'Active' : 'Inactive'}
                className="mobile-list__card__status"
              />
            </div>
          </div>
          <div className="mobile-list__card_body">
            <div className="mobile-list__card_body-left">
              <div className="mobile-list__card_item-name_wrapper">
                <PRZText
                  className="mobile-list__card_item-name"
                  text={`${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`?.trim()}
                />
              </div>
              <PRZText
                text={`BOM Name - ${(record?.bom_alias_name)}`}
                className="mobile-list__card_item-details"
              />
              <PRZText
                text={`Product SKU - ${(record?.internal_sku_code)}`}
                className="mobile-list__card_item-details"
              />
              <PRZText
                text={`Created Date - ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`}
                className="mobile-list__card_item-details"
              />
            </div>
            <div className="mobile-list__card_body-right">
              <Tooltip
                color="white"
                placement="top"
                title={(
                  <PRZText className="mobile-list__card_item__tooltip_text-color" text="Quantity" />
                )}
              >
                <PRZText
                  text={`${QUANTITY(record?.quantity, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
                />
              </Tooltip>
              <Tooltip
                color="white"
                placement="top"
                title={(
                  <PRZText className="mobile-list__card_item__tooltip_text-color" text="Components" />
                )}
              >
                <PRZText
                  text={record?.no_of_components || '0'}
                />
              </Tooltip>
            </div>
          </div>
          <Divider className="mobile-list__card_divider" />
          <div className="mobile-list__card_footer">
            <div className="mobile-list__card_footer-left">
              {record?.product_category_info?.category_path?.length > 0 && (
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={record?.product_category_info?.category_path?.join(' / ')}
                    />
                  )}
                  color="white"
                >
                  <div
                    className="mobile-list__card_item__category__wrapper"
                  >
                    {
                      `.../${record?.product_category_info?.product_category_name}`
                    }
                  </div>
                </Tooltip>
              )}
            </div>
            <div className="mobile-list__card_footer-right" />
          </div>
        </div>
      ),
      // responsive: ['xs'],
      hidden: !isMobile,
    },
    {
      title: 'BOM#',
      fixed: 'left',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      render: (text, record) => (
        <div className="min-width-50">
          {record?.bom_number}
        </div>
      ),
    },
    {
      title: 'BOM NAME',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      render: (text, record) => (
        <div className="min-width-70">
          <H3Text text={record?.bom_alias_name || '-'} className="bom-table__text" />
        </div>
      ),
    },
    {
      title: 'PRODUCT',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      render: (text, record) => (
        <div className="min-width-70">
          <div onClick={() => { setShowPRZModal(true); setSelectedDocumentId(record?.product_sku_id); }}>
            <a>
              {`#${record?.internal_sku_code}`}
            </a>
          </div>
          <H3Text text={`${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`?.trim()} />
        </div>
      ),
    },
    {
      title: 'CATEGORY',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      render: (text, record) => (
        <div className="min-width-70">
          {record?.product_category_info?.category_path?.length > 0 && (
            <ProductCategoryLabel
              categoryPath={record?.product_category_info?.category_path}
              categoryName={record?.product_category_info?.category_path?.at(
                -1,
              )}
              containerStyle={{
                width: 'fit-content',
              }}
            />
          )}
        </div>
      ),
    },
    {
      title: 'QUANTITY',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      render: (record) => <div className="min-width-70">{`${QUANTITY(record?.quantity, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>,
    },
    {
      title: 'COMPONENTS',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      render: (record) => <div className="min-width-85">{record?.no_of_components}</div>,
    },
    {
      title: 'STATUS',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      render: (text, record) => (
        <div className="qr__status min-width-50" style={{ backgroundColor: record?.is_active ? '#2fbc6e' : '#ee2232' }}>
          {record?.is_active ? 'Active' : 'Inactive'}
        </div>
      ),
    },
    {
      title: 'ATTACHMENTS',
      render: (text, record) => (
        <div className="min-width-100">
          {
            record?.attachments?.map((item, index) => (
              <div>
                <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
              </div>
            ))
          }
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
    },
    {
      title: 'CREATED DATE',
      render: (text, record) => (
        <div className="min-width-85">
          {toISTDate(record?.created_at).format('DD/MM/YYYY')}
          <H3Text text={record?.created_by_info?.first_name || 'Unknown'} className="table-subscript" />
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
    },
    {
      title: '',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      width: '60px',
      className: 'list__actions-column',
      render: (text, record) => (
        <div className="list__actions">
          {!isPortrait && (
            <div
              className="list__actions-button-dark list__actions-button"
              onClick={() => {
                if (!isRowDisabled(record)) {
                  // setSelectedBomId(record?.bom_id);
                  // setShowViewProductBOMModal(true);
                  // setSelectedBomProductName(record?.product_sku_name);
                  history.push(`/production/bom/view/${record?.bom_id}`);
                }
              }}
            >
              View
            </div>
          )}
          {Helpers.getPermission(Helpers.permissionEntities.BOM,
            Helpers.permissionTypes.UPDATE, user) && (
              <div
                className="list__actions-button"
                onClick={() => {
                  if (!isRowDisabled(record)) {
                    history.push(`/production/bom/update/${record?.bom_id}`);
                  }
                }}
              >
                <FontAwesomeIcon icon={faPen} />
              </div>
            )}
          {Helpers.getPermission(Helpers.permissionEntities.BOM,
            Helpers.permissionTypes.DELETE, user) && (
              <div>
                {!isRowDisabled(record) ? (
                  <Popconfirm
                    title="Are you sure you want to delete this BOM?"
                    placement="topRight"
                    onConfirm={() => {
                      deleteBOM({
                        org_id: record?.org_id,
                        bom_id: record?.bom_id,
                        is_archived: true,
                      }, () => {
                        setCall(!call);
                      });
                    }}
                  >
                    <div
                      className="list__actions-button-delete"
                    >
                      {deleteBOMLoading ? <LoadingOutlined /> : <FontAwesomeIcon icon={faTrash} />}
                    </div>
                  </Popconfirm>
                ) : (
                  <div
                    className="list__actions-button-delete-disabled"
                  >
                    <FontAwesomeIcon icon={faTrash}/>
                  </div>
                )}
              </div>
            )}
          {user?.tenant_info?.production_config?.addons?.access_restriction?.is_active && (
            <div
              className="list__actions-button"
            >
              {/* {!isRowDisabled(record) ? <UnlockOutlined /> : <LockOutlined />} */}
              {!isRowDisabled(record) ? <FontAwesomeIcon icon={faUnlock} /> : <FontAwesomeIcon icon={faLock} />}
            </div>
          )}
        </div>
      ),
      fixed: 'right',
    },
  ].filter((item) => !item.hidden);

  /**
   *
   * @param {*} word
   * @param {*} pg
   * @param {*} size
   * @param {*} status
   */
  const pushParamsToUrl = (word, pg, size, status, searchByRM) => {
    let url = '';
    if (pg) url += `?page=${pg}`;
    if (size) url += `&limit=${size}`;
    if (word) url += `&keyword=${word}`;
    if (status) url += `&status=${status}`;
    if (searchByRM) url += `&searchByRM=${searchByRM}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'searchByRM',
        filter_value: Helpers.getValueFromUrl('searchByRM') || '',
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }
  
  const initialFilterValues = useMemo(() => {
    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'status',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'searchByRM',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.BILL_OF_MATERIAL,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);


        setPage(Number(Helpers.getValueFromUrl('page') || page));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedStatus(tempFilterValues.status);
        setCreateBOMDrawer(Helpers.getValueFromUrl('toCreate') && Boolean(Helpers.getValueFromUrl('toCreate')));
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     setKeyword(Helpers.getValueFromUrl('keyword') || '');
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setPage(Number(Helpers.getValueFromUrl('page') || 1));
  //     setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
  //     setSelectedStatus(Helpers.getValueFromUrl('status') || null);
  //     setIsUserReady(true);
  //     setCreateBOMDrawer(Helpers.getValueFromUrl('toCreate') && Boolean(Helpers.getValueFromUrl('toCreate')));
  //   }
  // }, []);

  /**
   *
   */
  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(searchKeyword, page, limit, selectedStatus, selectedProductId, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getBOM(user?.tenant_info?.org_id, '', '', '', Helpers.getValueFromUrl('status') || '', page, limit, Helpers.getValueFromUrl('keyword'), Helpers.getTenantDepartmentId(user), 'list', '', Helpers.getValueFromUrl('searchByRM'));
    }
  }, [searchKeyword, page, limit, selectedStatus, call, selectedProductId, isUserReady
    // selectedFilterView
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchByProduct) {
        getProducts(searchByProduct, user?.tenant_info?.tenant_id, '', 5, 1, '', '', '', '', '', '', '');
      }
    }, 500); // 500ms debounce time
    return () => {
      clearTimeout(handler);
    };
  }, [searchByProduct]);

  const handleChange = (value, option) => {
    setSelectedProductId(value);
    setSelectedProducts(option);
  };

  const statusOptions = [
    { key: '', value: '', label: 'All Status' },
    { key: 'ACTIVE', value: 'true', label: 'Active' },
    { key: 'INACTIVE', value: 'false', label: 'Inactive' },
  ];

  return (
    <Fragment>
      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              alt="shopify icon"
              src={searchIcon}
              width={20}
              height={20}
              style={{ marginRight: 10 }}
            />
            <div>Search by Raw Material</div>
            &nbsp;  &nbsp;
            {getProductsLoading && <Spin size="small" />}
          </div>
        )}
        getContainer={() => document.querySelector('.trigger-modal-btn')}
        style={{
          top: '17px',
          left: isMobileOrPortrait ? '-1%' : '6%',
          width: '520px',
        }}
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        footer={null}
        mask
        maskClosable
        closeIcon={null}
      >
        <div className="section-search">
          <div className="section-search-bar__wrapper" style={{ width: '100%' }}>
            <PRZSelect
              showSearch
              mode="multiple"
              placeholder="Select a product"
              optionFilterProp="children"
              onSearch={(value) => setSearchByProduct(value)}
              value={selectedProductId}
              onChange={handleChange}
              loading={getProductsLoading}
              filterOption={(input, option) => option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0}
            >
              {products?.result?.products?.map((product) => (
                <Option key={product.product_sku_id} value={product.product_sku_id}>
                  {product?.product_info?.product_sku_name}
                </Option>
              ))}
            </PRZSelect>
          </div>
        </div>
      </Modal>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for bill of materials.."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setPage(1);
                            setLimit(10);
                          }
                        }}
                        onChange={(event) => setKeyword(event.target.value)}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="section-search">
                  <div className="search-by-product-modal-btn">
                    <H3Text
                      text={(
                        <div className="new-action-button-wrapper" onClick={() => setIsModalOpen(true)}>
                          <Fragment>
                            <div className="action-button-text">Search By Raw Material </div>
                            <div className="action-button-text_mobile">Search</div>
                            &nbsp;  &nbsp;
                            <H3Image src={searchIcon} className="action-button-icon" />
                          </Fragment>
                        </div>
                      )}
                      className="action-button action-button-big"
                    />
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                <div className="doc-list__buttons-wrapper">
                  {Helpers.getPermission(Helpers.permissionEntities.BOM, Helpers.permissionTypes.CREATE, user) && (
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      onClick={() => setShowBulkReturnsDrawer(true)}
                      customClass="add-button"
                      text="+ Import"
                    />
                  )}
                  {Helpers.getPermission(Helpers.permissionEntities.BOM, Helpers.permissionTypes.CREATE, user) && (
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      customClass="add-button"
                      onClick={() => {
                        history.push('/production/bom/create');
                      }}
                      text="+ New Bill of Material"
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    setPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.BILL_OF_MATERIAL}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {(selectedStatus === 'true' || selectedStatus === 'false') && (
                  <Tag closable onClose={() => { setSelectedStatus(null); setPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus === 'true' ? 'ACTIVE' : 'INACTIVE'}</b></span>
                  </Tag>
                )}
                {
                  selectedProductId?.length > 0 && selectedProductId?.map((item, index) => (
                    <Tag
                      key={index}
                      closable
                      onClose={() => {
                        setSelectedProductId(selectedProductId?.filter((id) => id !== item));
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      Product -
                      &nbsp;
                      <span><b>{selectedProducts?.find((product) => product.value === item)?.children}</b></span>
                    </Tag>
                  ))
                }
              </div>
            </div>  
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(billOfMaterials && billOfMaterials?.count) ? billOfMaterials?.count : '0'} Bills of Materials`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <Dropdown
                          trigger={['click']}
                          placement="bottom"
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div
                                className="filter__container inventory__header__section-status filter__container-section"
                              >
                                <div className="filter__title"> BOM Status </div>
                                <PRZSelect
                                  value={selectedStatus}
                                  onChange={(value) => {
                                    setSelectedStatus(value);
                                    setPage(1);
                                  }}
                                  placeholder="BOM Status"
                                  options={statusOptions}
                                />
                              </div>
                            </div>
                          )}
                        >
                          <div className="action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                bordered
                loading={getBOMLoading || deleteBOMLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && billOfMaterials && !!billOfMaterials?.bill_of_material?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && billOfMaterials && !!billOfMaterials?.bill_of_material?.length}
                columns={columns}
                dataSource={billOfMaterials && billOfMaterials?.bill_of_material ? billOfMaterials?.bill_of_material : []}
                pagination={
                  {
                    current: page,
                    defaultCurrent: page,
                    total: billOfMaterials ? billOfMaterials?.count : 0,
                    pageSize: limit,
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                    onChange: (pg, pageSize) => {
                      setPage(pg);
                      setLimit(pageSize);
                    },
                  }
                }
                rowClassName={(record) => (isRowDisabled(record) ? 'disabled-rows' : '')}
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        visible={showViewProductBOMModal}
        onClose={() => {
          setShowViewProductBOMModal(false);
          getBOMByIdSuccess(false);
        }}
        width="1080px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1030px' }}>
            <H3Text text="View Bill of Materials" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                getBOMByIdSuccess(false);
                setShowViewProductBOMModal(false);
              }}
            />
          </div>
        </div>
        <ProductBOM
          bomId={selectedBomId}
          callback={() => {
            setCall(!call);
            setShowViewProductBOMModal(false);
          }}
        />
      </Drawer>
      {/* <Drawer
        open={showUpdateBOMDrawer}
        width="1080px"
        mask
        onClose={() => setShowUpdateBOMDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1025px' }}>
            <H3Text text={`Update Bill of Materials - ${selectedBomProductName}`} className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateBOMDrawer(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <FormBOM
            bomId={selectedBomId}
            callback={() => {
              setShowUpdateBOMDrawer(false);
              setCall(!call);
            }}
          />
        </div>
      </Drawer> */}
      <Drawer
        open={showBulkReturnsDrawer}
        width="670px"
        mask
        onClose={() => setShowBulkReturnsDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '625px' }}>
            <H3Text text="Bulk Upload BOM" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowBulkReturnsDrawer(false)} />
          </div>
        </div>
        <BulkImportBOM callback={() => {
          getBOM(user?.tenant_info?.org_id, '', '', '', Helpers.getValueFromUrl('status') || '', page, limit, Helpers.getValueFromUrl('keyword'), Helpers.getTenantDepartmentId(user), 'list');
          setShowBulkReturnsDrawer(false);
        }}
        />
      </Drawer>
      <PRZModal
        isOpen={showPRZModal}
        onClose={() => {
          setShowPRZModal(false);
          setSelectedDocumentId(null);
        }}
        entityType="product"
        documentId={selectedDocumentId}
      />
      {/* <Drawer
        open={createBOMDrawer}
        width="980px"
        mask
        onClose={() => setCreateBOMDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '935px' }}>
            <H3Text text="Create New Bill of Materials" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setCreateBOMDrawer(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <FormBOM
            callback={() => {
              setCreateBOMDrawer(false);
              setCall(!call);
            }}
            listPage
          />
        </div>
      </Drawer> */}
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, BOMReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  billOfMaterials: BOMReducers.billOfMaterials,
  getBOMLoading: BOMReducers.getBOMLoading,
  deleteBOMLoading: BOMReducers.deleteBOMLoading,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getBOM: (orgId, tenantId, bomId, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, responseType, callback, searchBomByRm) => dispatch(BOMActions.getBOM(orgId, tenantId, bomId, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, responseType, callback, searchBomByRm)),
  getBOMSuccess: (billOfMaterials) => dispatch(BOMActions.getBOMSuccess(billOfMaterials)),
  deleteBOM: (payload, callback) => dispatch(BOMActions.deleteBOM(payload, callback)),
  getBOMByIdSuccess: (selectedBOM) => dispatch(BOMActions.getBOMByIdSuccess(selectedBOM)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BOMList));
